import { Button } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { busyWhile } from "lib/@components/busy/busy-while"
import { AssetRegisterRowMiddleCell } from "lib/@components/paging/paged-table/two-tone/asset-register-table-cells"
import { Frag } from "lib/@components/slot/frag"
import { DATE_FORMATS } from "lib/@constants/date-format"
import { Secure } from "lib/authorization/secure"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import Iconify from "minimals-template/components/Iconify"
import { createRegimeFromRegister } from "routes/asset-register/controller/create-regime-from-register"
import { RegimeDraftLockHide } from "../regime-draft-locking/regime-draft-lock-hide"

export function AddDateColumn({ row }) {
    return (
        <AssetRegisterRowMiddleCell>
            {new Date(row.modifiedDate).format(DATE_FORMATS.medium)}
        </AssetRegisterRowMiddleCell>
    )
}

export function AddSyncColumn({ row }) {
    const { syncType, regime } = useBoundContext()

    return (
        <Secure hide demand="syncAssetRegister" fallback={<Frag />}>
            <RegimeDraftLockHide>
                <AssetRegisterRowMiddleCell>
                    <Button
                        onClick={create}
                        color="primary"
                        startIcon={<Iconify icon="octicon:sync-16" />}
                        data-cy="sync-register-btn"
                    >
                        Synchronise
                    </Button>
                </AssetRegisterRowMiddleCell>
            </RegimeDraftLockHide>
        </Secure>
    )

    async function create() {
        if (syncType) {
            await busyWhile(async () => createRegimeFromRegister(row.id, regime._id, syncType), "Building Regime")
            successSnackbar("Register successfully synchronised")
        }
    }
}
